.titleSpan {
  font-weight: var(--font-weight-light);
}

.divider {
  height: 1px;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  border-color: black;
  border-width: 0.5px;
}

.transcribeRow {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.rightAligned {
  justify-content: flex-end;
}

.transcribeField {
  margin-bottom: 0 !important;
}

.field {
  margin-bottom: 0.5rem;
}
